/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Group_Creating_ContentInputs */



/**
* | output |
* | --- |
* | "Creating content" |
*
* @param {Onboarding_Usage_Group_Creating_ContentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_group_creating_content = /** @type {((inputs?: Onboarding_Usage_Group_Creating_ContentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Group_Creating_ContentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Inhalte erstellen")
	return /** @type {LocalizedString} */ ("Creating content")
});